module.exports = __webpack_public_path__ + "static/media/main.6222a3ac.png";